import classNames from "classnames";
import Loader from "./Loader";
import "./style.scss";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

const Loading = ({ text, notFullscreen, noText }: { text?: string; notFullscreen?: boolean, noText?:boolean }) => {
    const loaderClass = classNames("loading-wrapper", {
        ["not-fullscreen"]: notFullscreen
    });
    const { t } = useTranslation();

    return (
        <div className={loaderClass}>
            <Loader width="120" height="120" />
            {!noText && <OliverText text={text ? t("loading." + text) : t("loading.Builder Loading...")} size="l" weight="semi-bold" />}
        </div>
    );
};

export default Loading;
